import { Injectable } from '@angular/core';
import { SharedService } from '../shared/shared.service';
import { appConfig } from './../app.config';

@Injectable()
export class LoginService {

    constructor(
        public sharedService: SharedService) {

    }

    /**
     * API call for Login
     * @param data User Details
     */
    logIn(data, showSpinner: boolean = false) {
        const loginUrl = appConfig.logIn;
        return this.sharedService.postData(loginUrl, data, showSpinner);
    }

    /**
     * API call for Logout
     */
    logOut(showSpinner) {
        const logoutUrl = appConfig.logOut;
        return this.sharedService.deleteData(logoutUrl, showSpinner);
    }



}
